import { z } from "zod";

/**
 * Valeurs reprises d'un dossier d'inscription précédent du même prospect.
 *
 * Le serveur décide seul de ce qui est reprenable (`FIELD_SHARING_SCOPE`, financeur cible,
 * permissions de l'utilisateur) : ce schéma se contente de valider la forme du payload avant
 * qu'il n'alimente les `defaultValues` des formulaires de création. Les clés absentes signifient
 * "rien à reprendre", jamais "vider le champ".
 */
export const registrationPrefillValuesSchema = z
    .object({
        first_name: z.string().nullish(),
        last_name: z.string().nullish(),
        email: z.string().nullish(),
        mobile_phone: z.string().nullish(),
        profession: z.string().nullish(),
        birthdate: z.string().nullish(),
        dpc_rpps: z.string().nullish(),
        invoice_first_name: z.string().nullish(),
        invoice_last_name: z.string().nullish(),
        invoice_company_name: z.string().nullish(),
        invoice_company_siret: z.string().nullish(),
        invoice_street: z.string().nullish(),
        invoice_postal_code: z.string().nullish(),
        invoice_city: z.string().nullish()
    })
    .passthrough();

export const registrationPrefillSchema = z.object({
    source_registration_id: z.number(),
    source_reference: z.string().nullish(),
    source_funding_organism_name: z.string().nullish(),
    funding_organism_code: z.string().nullish(),
    values: registrationPrefillValuesSchema
});

export type RegistrationPrefillValues = z.infer<typeof registrationPrefillValuesSchema>;
export type RegistrationPrefillType = z.infer<typeof registrationPrefillSchema>;
